import { render, staticRenderFns } from "./UIResultMaxListNumberEdit.vue?vue&type=template&id=80a3c696&scoped=true"
import script from "./UIResultMaxListNumberEdit.vue?vue&type=script&lang=js"
export * from "./UIResultMaxListNumberEdit.vue?vue&type=script&lang=js"
import style0 from "./UIResultMaxListNumberEdit.vue?vue&type=style&index=0&id=80a3c696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a3c696",
  null
  
)

export default component.exports